import {BaseDTO} from 'src/app/modules/common/models/BaseDTO';
import {ApplicationRowDTO} from './ApplicationRowDTO';

export class BulkApplicationDTO extends BaseDTO {
  applications: ApplicationRowDTO[] = [];
}